export const BACKGROUND_COLOR = 'rgba(100, 100, 100, 0.7)';
export const PATTERN_COLOR = 'rgba(255, 255, 255, 0.8)';
export const POINT_STYLE = 'round';
